import moment from 'moment';
import 'moment/locale/es';

moment.locale('es');

const DATE_FORMAT_DEFAULT = 'DD/MM/YYYY';
const DATE_FORMAT_ISO = 'YYYY-MM-DDTHH:mm:ss';
const DATE_FORMAT_REMPLACEMENT_VEHICLE = 'YYYY-MM-DD';
const HOURS = 'HH:mm';

export const dateToday = () => moment();

export const dateToString = (val, format = DATE_FORMAT_DEFAULT) => {
  const date = moment(val);
  if (!val || !date.isValid() || date.year() < 1960) {
    return '-';
  }

  return date.format(format);
};

export const stringToDate = (val, format = DATE_FORMAT_DEFAULT) => moment(val, format);

export const dateToISO = (val, format = DATE_FORMAT_DEFAULT) =>
  val ? moment(val, format).format(DATE_FORMAT_ISO) : '';

export const dateToFormatRemplacementVehicle = (val, format = DATE_FORMAT_DEFAULT) =>
  val ? moment(val, format).format(DATE_FORMAT_REMPLACEMENT_VEHICLE) : '';

export const hours = (val, format = DATE_FORMAT_ISO) =>
  val ? moment(val, format).format(HOURS) : '';

export const getMonthsDiffBetweenDates = (dateInitial, dateFinal) =>
  Math.max(
    (dateFinal.getFullYear() - dateInitial.getFullYear()) * 12 +
      dateFinal.getMonth() -
      dateInitial.getMonth(),
    0
  );
